export default {
  methods: {
    productDisplayName: function (input) {
      var self = this
      var toReturn = []
      var variables = self.$store.getters.clientVariables
      let result = variables.find(variable => variable.name === 'productDisplayName')

      var constructor = result.value.split(':')

      for (var item in constructor) {
        var prop = constructor[item].toString().replace('{', '').replace('}', '')
        toReturn.push(input[prop])
      }

      return toReturn.join(result.join)
    },
    imageName: function (input) {
      var self = this
      var toReturn = []
      var variables = self.$store.getters.clientVariables
      let result = variables.find(variable => variable.name === 'imageName')

      var constructor = result.value.split(':')

      for (var item in constructor) {
        var prop = constructor[item].toString().replace('{', '').replace('}', '')
        toReturn.push(input[prop])
      }

      return toReturn.join(result.join)
    },
    quickInfo: function (input) {
      var self = this
      var toReturn = []
      var variables = self.$store.getters.clientVariables
      let result = variables.find(variable => variable.name === 'quickInfo')

      var constructor = result.value.split(':')
      var data_master = JSON.parse(input['data_master'])

      for (var item in constructor) {
        var prop = constructor[item].toString().replace('{', '').replace('}', '')

        // if input is an object, convert it

        toReturn.push({
          'name': prop,
          'value': data_master[prop] || input[prop] || ''
        })
      }

      return toReturn
    },
    modelInfo: function (input) {
      var self = this
      var toReturn = []
      var constructor = ['model_name', 'model_gender', 'model_stats', 'model_agency_name']

      for (var item in constructor) {
        var prop = constructor[item].toString().replace('{', '').replace('}', '')
        toReturn.push({
          'name': prop,
          'value': input[prop]
        })
      }

      return toReturn
    },
    getProductImages: function () {
      var self = this
      const url = '/imagedesk/image/all'

      let data = {
        id_product: self.selectedProduct.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productImages = response.data.images
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    },
    getProductComments: function () {
      var self = this
      const url = '/productdesk/product/comment'
      let data = {
        id_product: self.selectedProduct.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productComments = response.data.product_comments
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    getProductIntegrations: function () {
      var self = this
      const url = '/productdesk/product/integration'

      let data = {
        id_product: self.selectedProduct.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productIntegrations = response.data.product_integrations
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    getProductHistory: function () {
      var self = this
      const url = '/productdesk/product/history'

      let data = {
        id_product: self.selectedProduct.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productHistory = response.data.product_history
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    getProductCopy: function () {
      var self = this
      const url = '/copydesk/product/details/'
      let data = {
        'id_product': self.selectedProduct.id_product
      }

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.productRevisions = response.data.copy_revisions
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
        })
    },
    getProductCopyDuplicate: function () {
      var self = this
      const url = '/copydesk/product/details/'
      let data = {
        'id_product': self.selectedProduct.id_product
      }

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.productCopy = response.data.product_copy
          self.productRevisions = response.data.copy_revisions
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
        })
    },

    getProductAssociates: function () {
      var self = this
      const url = '/productdesk/product/associate'
      let data = {
        'id_product': self.selectedProduct.id_product
      }

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.selectedProductAssociates = response.data.product_associates
          self.productAssociates = response.data.product_associates
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
        })
    },

    async addProductAssociates () {
      var self = this
      const url = '/productdesk/product/associate/add'
      let data = {
        'id_product': self.selectedProduct.id_product,
        'identifier': self.searchAssociate
      }

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          return 'ok'
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
          return 'ok'
        })
    },

    getRetouchAgencies: function () {
      var self = this
      const url = '/orgdesk/retouchagencies'

      this.$http.post(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          var agencies = response.data.retouch_agency
          agencies.forEach(function (agency) {
            var conditions = JSON.parse(agency.conditions) || null
            var rank = 0
            for (var item in conditions) {
              if (self.selectedProduct[item] === conditions[item]) {
                rank++
              }
            }
            agency['rank'] = rank
          })
          agencies.sort(function (a, b) {
            if (b.rank == a.rank) {
              return b.is_default > a.is_default
            }
            return b.rank > a.rank
          })

          // if (agencies[0].code != self.selectedProduct.retouch_agency_code) {
          //   self.updateRetouchAgency(agencies[0].id_retouch_agency)
          // }

          self.retouchAgencies = agencies
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
        })
    },
    skipProductSession: function (session) {
      var self = this
      const url = '/productdesk/product/session/skip'
      let data = {
        'id_product': self.selectedProduct.id_product,
        'skip_session': session
      }
      self.$emit('refreshInterface')
      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Session skipped',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },
    requireProductSession: function (session) {
      var self = this
      const url = '/productdesk/product/session/require'
      let data = {
        'id_product': self.selectedProduct.id_product,
        'require_session': session
      }
      self.$emit('refreshInterface')
      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Session restored',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },
    updateProduct: function () {
      var self = this
      const url = '/productdesk/product/view'

      let data = {
        id_product: self.selectedProduct.id_product
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data
          self.pendingRefresh = 0
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    updateProductPhotodesk: function (id_photodesk_session) {
      var self = this
      const url = '/productdesk/product/view'

      let data = {
        id_product: self.selectedProduct.id_product,
        id_photodesk_session: id_photodesk_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data
          self.pendingRefresh = 0
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    updateRetouchAgency: function (id_retouch_agency) {
      var self = this
      const url = '/productdesk/product/dispatch/update'

      let data = {
        id_product: self.selectedProduct.id_product,
        id_retouch_agency: id_retouch_agency
      }

      self.pendingRefresh = 1

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.updateProduct()
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    updatePretouchPath: function (path) {
      var self = this
      const url = '/productdesk/product/pretouchpath/update'

      let data = {
        id_product: self.selectedProduct.id_product,
        path: path
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.updateProduct()
          self.pretouchPathPendingUpdate = false
        })
        .catch(function (error) {
          console.log(error.response)
        })
    }
  }
}
